<template>
    <FileImportDialog :alvqaContext="alvqa +'-list'">
      <template v-slot:importOptions>
            <div align="center">
                <BasePeriod 
                    context="ImportDialog"
                    periodLabel="lang_GENERAL_CAPTION_UPLOADER_PERIOD_OPTIONAL"
                    widthTimeUnitField="4"
                    :undefinedTimeUnit="true"
                    justify="center"
                />
            </div>
            <v-row v-if="$store.getters.getSelectedFileImportOption  && $store.getters.getSelectedFileImportOption.mappings && $store.getters.getSelectedFileImportOption.mappings.length > 0">
                <v-col>
                    <!-- Context = PublishingIncome -->
                    <BaseEditPageDropdown 
                        field="Abbreviation"
                        :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                        :items="abbreviationsOptions"
                        :context="context"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-abbreviation'"
                    />
                </v-col>
            </v-row>
          <v-row>
              <v-col class="pb-1">                        
                  <span class="black-label">
                      <v-checkbox 
                          v-model="selectedIncomeCheckboxes"
                          value="runErrorLists"
                          hide-details 
                          color="generalCheckbox"  
                          class="mt-0"
                          :alvqa="alvqa + '-checkbox-run-error-lists'"
                      >
                          <template v-slot:label>
                              <span 
                                class="black--text pt-1"
                                :alvqa="alvqa + '-checkbox-run-error-lists-text'"
                              >{{ $t('lang_GENERAL_CAPTION_UPLOADER_RUN_ERROR_LISTS') }}</span>
                          </template>
                      </v-checkbox>
                  </span>
              </v-col>
          </v-row>
          <v-row>
              <v-col class="pt-1">
                  <v-checkbox 
                      v-model="selectedIncomeCheckboxes"
                      value="withoutAssigning"
                      hide-details
                      color="generalCheckbox" 
                      class="mt-0"
                      :alvqa="alvqa + '-checkbox-without-assigning'"
                  >
                      <template v-slot:label>
                          <span 
                            class="black--text pt-1"
                            :alvqa="alvqa + '-checkbox-without-assigning-text'"
                          >{{ $t('lang_PUBLISHING_SALES_DATA_UPLOADER_NO_ASSING_TO_COMPANY') }}</span>
                      </template>
                  </v-checkbox>
              </v-col>
          </v-row>
          <v-row>
                <v-col cols="5">
                    <BaseEditPageTextField
                        :context="context"
                        field="ImportCommissionPercent"
                        :label="$t('lang_PUBLISHING_INCOME_CAPTION_COMMISSION_PERCENT')"
                        :withMargin="false"
                        rules='percent3Decimals'
                        :alvqa="alvqa + '-textfield-commission-percent'"
                    />
                </v-col>
                
                
                <v-col cols="7"> 
                    <BaseEditPageTextField
                        :context="context"
                        field="ImportCurrencyConversionFactor"
                        :label="$t('lang_GENERAL_CAPTION_CONVERSION_FACTOR')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-currency-conversion-factor'"
                    />
                </v-col>
          </v-row>
      </template>
    </FileImportDialog>
</template>

<script>
import FileImportDialog from '@/components/_dialogs/FileImportDialog'
import BasePeriod from '@/components/_base/BasePeriod'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name: "IncomeFileImportDialog",
    components: {
        FileImportDialog,
        BasePeriod,
        BaseEditPageDropdown,
        BaseEditPageTextField
    },
    data() {
        return {
            userLoginId: this.$store.getters["getUserInformation"].id,
            alvqa: 'publishing-income-list-import-dialog',
            context: 'PublishingIncome'
        }
    },
    computed: {
        selectedIncomeCheckboxes: {
            get() { return this.$store.getters.getSelectedImportDialogCheckboxes },
            set(options) { this.$store.commit('setSelectedImportDialogCheckboxes', options)}
        },
        abbreviationsOptions() {
            if(!this.$store.getters.getSelectedFileImportOption || !this.$store.getters.getSelectedFileImportOption.mappings) {
                return []
            }

            let mappings = this.$store.getters.getSelectedFileImportOption.mappings
            mappings.sort((a, b) => {
                if (a.disabled === true) return 1; // Put disabled at the end
                if (b.disabled === true) return -1;
            })

            return mappings
        }
    },
    methods: {
        showCurrencyConversionFactor() {
            let showCCF = false
            let selectedImporter = this.$store.getters.getSelectedFileImport

            showCCF = 
                selectedImporter === 'edition_björlund'  ||
                selectedImporter === 'bmg_us'           ||
                selectedImporter === 'iqmusic'          ||
                selectedImporter === 'musicreports'     ||
                selectedImporter === 'maestroAt'        ||
                selectedImporter === 'suisa'

            return showCCF
        }
    },
}
</script>